const getObjectByNameFromArray = (arr, name) => arr?.find((item) => item?.name === name) || {};

export const generateTableHead = (access, columns, type = 'main') => {
  switch (type) {
  case 'main':
    if (!access || !columns) {
      return [];
    }
    return [
      { title: 'ID', access: true, class: 'p-l', ...getObjectByNameFromArray(columns, 'id') },
      { title: 'User', access: true, attrs: { style: { minWidth: '100px' } }, ...getObjectByNameFromArray(columns, 'user_name') },
      { title: 'Balance', access: true, attrs: { style: { minWidth: '100px' } }, ...getObjectByNameFromArray(columns, 'balance') },
      { title: 'Amount', access: true, attrs: { style: { minWidth: '100px' } }, ...getObjectByNameFromArray(columns, 'amount') },
      { title: 'Method', access: true, attrs: { style: { minWidth: '200px' } } },
      { title: 'Status', access: true, attrs: { style: { minWidth: '100px' } } },
      { title: 'Fraud risk', access: true },
      { title: 'Memo', access: true, attrs: { width: '20%' } },
      { title: 'Created', access: true, attrs: { width: '10%' }, ...getObjectByNameFromArray(columns, 'created') },
      { title: 'Updated', access: true, attrs: { width: '10%' }, ...getObjectByNameFromArray(columns, 'updated') },
      { title: 'Mode', access: true },
      { title: '', access: true },
    ].filter((item) => item.access);

  case 'export':
    return [
      { title: 'From', access: true, class: 'p-l' },
      { title: 'To', access: true },
      { title: 'Users', access: true },
      { title: 'Methods', access: true },
      { title: 'Status', access: true },
      { title: 'Modes', access: true },
      { title: 'Format', access: true },
      { title: 'Created', access: true },
      { title: '', access: access?.export_download },
    ].filter((item) => item.access);

  default:
    break;
  }
};

export const generateTableBody = (item, type = 'main', access) => {
  switch (type) {
  case 'main':
    return [
      { type: 'id', value: item.id, class: 'p-l' },
      { type: 'user', value: item.user_name, attrs: { style: { minWidth: '100px' } } },
      { type: 'balance', value: item.balance, attrs: { style: { minWidth: '100px' } } },
      { type: 'amount', value: item.amount, attrs: { style: { minWidth: '100px' } } },
      { type: 'method', value: item.method_name, attrs: { style: { minWidth: '200px' } } },
      { type: 'status', value: item.status_title, attrs: { style: { minWidth: '100px' } } },
      { type: 'fraud_risk', value: item.fraud_risk_title },
      { type: 'memo', value: item.memo, attrs: { width: '20%' }, class: 'payments__table-td--memo' },
      { type: 'created', value: item.created, class: 'p-r', attrs: { width: '10%' } },
      { type: 'updated', value: item.updated, class: 'p-r', attrs: { width: '10%' } },
      { type: 'mode', value: item.mode_title },
      { type: 'actions', value: null, class: 'td-caret' },
    ];

  case 'export':
    return [
      { type: 'from', value: item.from_date, class: 'p-l', access: true },
      { type: 'to', value: item.to_date, access: true },
      { type: 'users', value: item.users === null ? 'All' : item.users, access: true },
      { type: 'methods', value: item.methods === null ? 'All' : item.methods, access: true },
      { type: 'status', value: item.statuses === null ? 'All' : item.statuses, access: true },
      { type: 'modes', value: item.mode, access: true },
      { type: 'format', value: item.format, access: true },
      { type: 'created', value: item.date, access: true },
      { type: 'id', value: item.id, access: access?.export_download },
    ].filter((item) => item.access);

  default:
    return [];
  }
};

export const getItemActions = (item, access) => [
  {
    title: 'Accept payment',
    id: 0,
    access: item?.access?.accept && access?.complete,
  },
  {
    title: 'Complete payment',
    id: 1,
    access: item?.access?.complete && access?.complete,
  },
  {
    title: 'Details',
    id: 2,
    access: item?.access?.view_details && access?.response,
  },
  {
    title: 'Details for superadmin',
    id: 3,
    access: item?.access?.view_details_for_superadmin && access?.response_superadmin,
  },
  {
    title: 'Edit',
    id: 4,
    access: item?.access?.edit && access?.edit,
  },
  {
    title: 'Report a fraud',
    id: 5,
    access: item?.access?.report && access?.fraud_report,
  },
  {
    title: 'Reject',
    id: 6,
    access: item?.access?.reject && access?.reject,
  },
].filter((item) => item.access);

/**
 * @function
 * @name getSelectedMethods
 * @description Получаем активные options для селекта
 * @param {array} methods
 * @param {array} selectedMethods
 * @returns {array}
 */
export const getSelectedMethods = (methods, selectedMethods) => {
  if (methods.length && selectedMethods?.length) {
    return methods.filter((method) => !!selectedMethods.includes(String(method.id)));
  }
  return [];
};

export const dropdownStatusFormatted = (statuses) => {
  if (statuses?.length) {
    return statuses.map((status) => ({
      ...status,
      badge: status?.id === 6 && status?.count,
    }))
  }

  return [];
}
